import { render, staticRenderFns } from "./media_holding.vue?vue&type=template&id=16f51200&scoped=true"
import script from "./media_holding.vue?vue&type=script&lang=js"
export * from "./media_holding.vue?vue&type=script&lang=js"
import style0 from "./media_holding.vue?vue&type=style&index=0&id=16f51200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f51200",
  null
  
)

export default component.exports